import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../dashboard/claimLitigation/litigation.scss";
import { updateFlag, fetchFlagDetails } from "./litigationApi";
import AsteriskSymbol from "../../reusableComponents/AsteriskSymbol";
import { flagClaimsMaxLength, FRAUD, Litigationvalidtypes, REGEX } from "../../consts";
import { Button, Modal, ModalBody, ModalFooter } from "react-bootstrap";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import FileUpload from "../../utilsComponent/fileUpload";
import { formatDocumentDetails } from "./helper";
import FlagClaimsAccordion from "../../utilsComponent/FlagClaimsAccordion";

const Fraud = (props) => {
  const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
  const [loading, setLoading] = useState(false);
  const [flagFraud, setFlagFraud] = useState(false);
  const [remarksInModal, setRemarksInModal] = useState("");
  const [fraudModal, setFraudModal] = useState(false);
  const [previousFlagFraud, setPreviousFlagFraud] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (claimDetailCookie?.claimNo) {
      getFraudDetails();
    }
  }, [claimDetailCookie?.claimNo]);

  const getFraudDetails = () => {
    setLoading(true);
    fetchFlagDetails(claimDetailCookie?.claimNo, FRAUD, setLoading)
      .then((data) => {
      setRows(data?.records)
      if (!data?.records?.length) {
        setFlagFraud(false);
        setPreviousFlagFraud(false);
      } else {
        const latestActivity = data?.records[0]?.activityName || "";
        if (latestActivity === "Fraud Unflagged") {
          setFlagFraud(false);
          setPreviousFlagFraud(true);
        } else if (latestActivity === "Fraud Flagged" || latestActivity === "Fraud Re-flagged") {
          setFlagFraud(true);
          setPreviousFlagFraud(true);
        }
      }
      })
      .catch((error) => {
        console.error("Error fetching Fraud details:", error);
        setFlagFraud(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFlagFraud = () => {
    const isFraudChecked = !flagFraud;
    setPreviousFlagFraud(flagFraud);
    setFlagFraud(isFraudChecked);
    setFraudModal(true);
  };
  const submitFraud = async () => {
    if (
      claimDetailCookie.assignedTo === "Unassigned" ||
      !claimDetailCookie.assignedTo
    ) {
      toast.error("Please Assign Claims Handler.");
      return;
    }
    if (!remarksInModal) {
      toast.error("Please enter remarks");
      return;
    }
    setLoading(true);
    const response = await updateFlag({
      claimId: claimDetailCookie.claimNo,
      flagId: FRAUD,
      userId: roleDataCookie?.userID,
      remarks: remarksInModal,
      documentId: addedFiles.map((list) => list.id)
    },setLoading);
    setLoading(false);
    toast.success(response);
    getClaimDetails(claimDetailCookie?.claimNo);
    getFraudDetails();
    setRemarksInModal("");
    setFraudModal(false);
    setAddedFiles([]);
  };
  const handleModalClose = () => {
    setFlagFraud(previousFlagFraud);
    setFraudModal(false);
    setRemarksInModal("");
    setAddedFiles([]);
  };

  return loading ? (
    <LoadingPage />
  ) : (
    <div>
      <div>
        <div className="potential">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="flagFraud"
              checked={flagFraud}
              onClick={handleFlagFraud}
              readOnly
            />
            <label className="form-check-label mb-3" htmlFor="flagFraud">
              Flag a Fraud
            </label>
          </div>
          {fraudModal && (
            <Modal
              show={fraudModal}
              isOpen={fraudModal}
              centered={true}
              backdrop={"static"}
              className="fraud-modal-width"
            >
              <ModalBody>
                <div>
                  <label>
                    <h6>
                      Remarks <AsteriskSymbol />
                    </h6>
                  </label>
                </div>
                <div>
                  <textarea
                    className="remarksPotential"
                    placeholder="Please enter remarks"
                    value={remarksInModal}
                    onChange={(e) => {
                      const fraudRemarks = e.target.value
                        .replace(REGEX.ALPHANUM_SPACE, "")
                        .slice(0, flagClaimsMaxLength);
                      setRemarksInModal(fraudRemarks);
                    }}
                  ></textarea>
                  <div className="remarks-text-info right">
                    <p>
                      {remarksInModal.length}/{flagClaimsMaxLength}
                    </p>
                  </div>
                  <FileUpload
                    validtype={Litigationvalidtypes}
                    addedFiles={addedFiles}
                    setAddedFiles={setAddedFiles}
                    text={"Upload File"}
                    module="litigation"
                    roleDataCookie={roleDataCookie}
                    doctypeName="litigation"
                    tran_id={claimDetailCookie?.claimNo}
                />
                </div>
              </ModalBody>
              <ModalFooter className="justify-content-center">
                <Button
                  variant="outline-danger"
                  onClick={handleModalClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outline-success"
                  onClick={() => submitFraud()}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <FlagClaimsAccordion
            rows={rows}
            formatDocumentDetails={formatDocumentDetails}
          />
        </div>
      </div>
    </div>
  );
};

export default Fraud;
